/* eslint-disable radix */
import RestService from '../services/rest';


async function getListProductFeedbackReason(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/productFeedbackReason/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function updateProductFeedbackReason(productFeedbackReasonParameter) {
  return RestService.putAuthenticated('panel/productFeedbackReason/update', productFeedbackReasonParameter);
}

async function createProductFeedbackReason(newProductFeedbackReason) {
  return RestService.postAuthenticated('panel/productFeedbackReason/create', newProductFeedbackReason);
}

export default {
  createProductFeedbackReason,
  updateProductFeedbackReason,
  getListProductFeedbackReason,
};
